export default {
    state: () => ({
        doctors: [
            {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
             {
                name: "dr. John Doe",
                department: "Refractiva",
                specialty: "Refractivologo",
                image: "/doctor.jpeg"
            },
              {
                name: "dr. John Doe",
                department: "Cornea",
                specialty: "Corneologo",
                image: "/doctor.jpeg"
            },
               {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
             {
                name: "dr. John Doe",
                department: "Retina",
                specialty: "Retinologo",
                image: "/doctor.jpeg"
            },
              {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
               {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
             {
                name: "dr. John Doe",
                department: "Refractiva",
                specialty: "Refractivologo",
                image: "/doctor.jpeg"
            },
              {
                name: "dr. John Doe",
                department: "Cornea",
                specialty: "Corneologo",
                image: "/doctor.jpeg"
            },
               {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
             {
                name: "dr. John Doe",
                department: "Retina",
                specialty: "Retinologo",
                image: "/doctor.jpeg"
            },
              {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
               {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
             {
                name: "dr. John Doe",
                department: "Refractiva",
                specialty: "Refractivologo",
                image: "/doctor.jpeg"
            },
              {
                name: "dr. John Doe",
                department: "Cornea",
                specialty: "Corneologo",
                image: "/doctor.jpeg"
            },
               {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
             {
                name: "dr. John Doe",
                department: "Retina",
                specialty: "Retinologo",
                image: "/doctor.jpeg"
            },
              {
                name: "dr. John Doe",
                department: "Glaucoma",
                specialty: "Glautomologo",
                image: "/doctor.jpeg"
            },
        ]
    }),
    getters: {
        getDoctors: (state) => state.doctors,
    },
    actions: {},
    mutations: {},
    namespaced: true,
};